import { AdcampaignPlaybackReportTypeForInput } from 'domain/api/graphql/generated';

import { TEXTS } from './texts';

export const REPORT_MODAL_TITLE_BY_REPORT_TYPE: Record<AdcampaignPlaybackReportTypeForInput, string> = {
  [AdcampaignPlaybackReportTypeForInput.AudioAds]: TEXTS.AUDIO_ADS_REPORT_MODAL_TITLE,
  [AdcampaignPlaybackReportTypeForInput.VideoAds]: TEXTS.VIDEO_ADS_REPORT_MODAL_TITLE,
  [AdcampaignPlaybackReportTypeForInput.VideoWaves]: TEXTS.VIDEO_WAVES_REPORT_MODAL_TITLE,
};
